import { init as keyInit } from '@accedo/virtual-key';
import { deviceApi } from '@accedo/ctv-device-api';
import intl from 'intl';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import intlCollator from 'intl-collator';
import { redirectIfSpecNotSupported } from '##/utils';

// Chrome 38 polyfills (fetch, etc.) - swapped to empty module for modern browsers
import '##/overrides/chrome38';

import App from './App';
import './styles/index.scss';

if (!window.Intl) {
  if (!intl.Collator) {
    intl.Collator = intlCollator;
  }

  window.Intl = intl;
}

if (!window.Promise.all) {
  // Polyfill for Promise.all()
  window.Promise.all = (promises: Promise<unknown>[]): Promise<unknown[]> =>
    new Promise((resolve, reject) => {
      let numCompleted = 0;
      const results: unknown[] = promises.map(() => null);
      promises.forEach((promise, index) => {
        promise
          .then((result) => {
            results[index] = result;
            numCompleted += 1;
            if (numCompleted === promises.length) {
              resolve(results);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    });
}

redirectIfSpecNotSupported();
keyInit();
setTimeout(() => {
  deviceApi.lifecycle?.ready();
}, 0);

export default App;
